import { create } from "zustand"
import { persist } from "zustand/middleware"

interface NewPortalHintState {
	dismissedWorkspaceIds: string[]
	dismiss: (workspaceId: string) => void
}

export const useNewPortalHintState = create<NewPortalHintState>()(
	persist(
		(set) => ({
			dismissedWorkspaceIds: [],
			dismiss: (workspaceId) =>
				set((state) =>
					state.dismissedWorkspaceIds.includes(workspaceId)
						? state
						: {
								dismissedWorkspaceIds: [
									...state.dismissedWorkspaceIds,
									workspaceId,
								],
							},
				),
		}),
		{
			name: "new-portal-hint-state",
		},
	),
)
